import { intl } from '../platform/localization'

export const messages = {
  get textNotifyReminderCompleted() {
    return intl.formatMessage({
      defaultMessage: 'Reminder Has Been Completed!',
      description: 'Text notify if reminder has been completed',
    })
  },
  get textErrorMessageReminderNotCreated() {
    return intl.formatMessage({
      defaultMessage: "Reminder can't be created without a recipient",
      description: "Text error message if reminder can't be created",
    })
  },
  get textNotifyReminderCreated() {
    return intl.formatMessage({
      defaultMessage: 'Reminder Has Been Created!',
      description: 'Text notify if reminder has been created',
    })
  },
  get textNotifyRecipientDNC() {
    return intl.formatMessage({
      defaultMessage: 'Recipients are either marked DNC or have email contact restrictions',
      description:
        'Text notify recipients are either marked DNC or have email contact restrictions',
    })
  },
  get textNotifyNoAccessToRecipients() {
    return intl.formatMessage({
      defaultMessage: 'You do not have read access to these recipients',
      description: 'Text notify no access to recipients',
    })
  },
  get textNotifyUnableToAssignCadenceToUser() {
    return intl.formatMessage({
      defaultMessage:
        'Unable to Assign Cadence to User. This user does not have object access to a Person',
      description: 'Text notify unable to Assign Cadence to User',
    })
  },
  get textNotifyChangeDueDateForCadence() {
    return intl.formatMessage({
      defaultMessage: 'Due Date Changed',
      description: 'Text notify change due date for cadence',
    })
  },
  textNotifyPersonAddedToCadence(personName: string, cadenceName: string) {
    return intl.formatMessage(
      {
        defaultMessage: '{personName} was added to {cadenceName}',
        description: 'Text notify person was added to cadence',
      },
      {
        personName,
        cadenceName,
      }
    )
  },
  textNotifyPersonRemovedFromCadence(personName: string, cadenceName: string) {
    return intl.formatMessage(
      {
        defaultMessage: '{personName} was removed from {cadenceName}',
        description: 'Text notify person was removed from cadence',
      },
      {
        personName,
        cadenceName,
      }
    )
  },
}
